import React from 'react';
import './SectionContact.scss';

import Contact from './../forms/Contact/Contact';


function SectionContact() {
  
  return (
    <div className="section-contact">
      <div className="container">
        <Contact></Contact>
      </div>
    </div>
  );
}

export default SectionContact;
